import { IProduct } from "../../models/catalogue";
import { ISafeHTML, isoProductID, isoSafeHTML } from "../../models/nominals";
import { ICompareTile } from "../../models/product-compare";
import { IGA4ListMetadata } from "../../utils/analytics";
import { notEmpty } from "../../utils/functional";
import { slugify } from "../../utils/text";
import { getSelectedVariant } from "./selectors";

const DEFAULT_LIST_NAME = "Product Compare";
const DEFAULT_LIST_ID = "product-compare";

const stripHTMLToText = (
    html: string | ISafeHTML | null | undefined,
): string => {
    if (!html) {
        return "";
    }

    const rawHTML = typeof html === "string" ? html : isoSafeHTML.unwrap(html);
    return rawHTML
        .replace(/<[^>]*>/g, " ")
        .replace(/\s+/g, " ")
        .trim();
};

export const defaultProductCompareListMetadata: IGA4ListMetadata = {
    item_list_id: DEFAULT_LIST_ID,
    item_list_name: DEFAULT_LIST_NAME,
};

export const buildProductCompareListMetadata = (
    heading: string | ISafeHTML | null | undefined,
    fallbackName: string,
): IGA4ListMetadata => {
    const itemListName =
        stripHTMLToText(heading) || fallbackName || DEFAULT_LIST_NAME;
    const itemListID =
        slugify(stripHTMLToText(heading)) ||
        slugify(fallbackName) ||
        DEFAULT_LIST_ID;

    return {
        item_list_id: itemListID,
        item_list_name: itemListName,
    };
};

export const resolveProductCompareTrackedProducts = (
    tiles: readonly ICompareTile[],
    priceSelectValue: string | null,
): readonly IProduct[] => {
    return tiles
        .map((tile) => getSelectedVariant(tile, priceSelectValue))
        .filter(notEmpty);
};

export const buildTrackedProductsSignature = (
    products: readonly IProduct[],
): string => {
    return products
        .map((product) => String(isoProductID.unwrap(product.id)))
        .join("|");
};
